import { useLongPress } from "@uidotdev/usehooks";

import type { Table } from "~/providers/table-provider";
import { useCustomLongPress } from "~/hooks/use-long-press";
import { cn } from "~/lib/utils";
import { useFloorPlanStore } from "~/stores/use-floor-plan-store";
import { useRegisterStore } from "~/stores/use-register-store";
import AudioButton from "../ui/audio-button";
import { TableComponent } from "./tables/table";

export function FloorPlanItem({
  table,
  onClick,
  onMouseDown,
  onMouseUp,
  onMouseLeave,
  onContextMenu,
  className,
  style,
  children,
}: {
  table: Table;
  onClick?: () => void;
  onMouseDown?: () => void;
  onMouseUp?: () => void;
  onMouseLeave?: () => void;
  onContextMenu?: () => void;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}) {
  const { selectedSection } = useRegisterStore();
  const { getIsPanning, getIsZooming } = useFloorPlanStore();

  const handleTableContextMenu = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.preventDefault();
    e?.stopPropagation();
    if (getIsPanning() === false && getIsZooming() === false && onContextMenu) {
      onContextMenu();
    }
  };

  const attrs = useCustomLongPress(
    () => {
      handleTableContextMenu();
    },
    {
      threshold: 500,
      movementThreshold: 10,
    },
  );

  return (
    <AudioButton
      style={{
        ...style,
        transform: `rotate(${table.rotation}deg)`,
      }}
      {...attrs}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
      onClick={(e) => {
        if (onClick) {
          onClick();
        }
        e.stopPropagation();
      }}
      className={cn(selectedSection?.id !== table.locationId && "hidden")}
      onContextMenu={handleTableContextMenu}
    >
      <TableComponent
        rotation={table.rotation}
        shape={table.shape}
        numChairs={table.maxSeats}
        className={cn(className)}
        reference={table.reference}
      />
      {children}
    </AudioButton>
  );
}
